(() => {
  const alignInquiry = (behavior) => {
    const target = document.getElementById('rdr21-b2b-inquiry');
    if (!target) return false;

    const header = document.querySelector('.shopify-section:has(> .rdr21-header)');
    const productNav = document.querySelector('.rdr21-product-subnav');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const productNavHeight = productNav?.getBoundingClientRect().height || 0;
    const offset = headerHeight + productNavHeight + 12;
    const top = window.scrollY + target.getBoundingClientRect().top - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior,
    });
    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.rdr21-product-subnav__business[href="#rdr21-b2b-inquiry"]');
    if (!link || !document.getElementById('rdr21-b2b-inquiry')) return;

    event.preventDefault();
    if (window.location.hash !== '#rdr21-b2b-inquiry') {
      window.history.pushState(null, '', '#rdr21-b2b-inquiry');
    }

    requestAnimationFrame(() => {
      alignInquiry('smooth');
      window.setTimeout(() => alignInquiry('auto'), 800);
    });
  });
})();
